import './_collection-footer.scss';
import component from './collection-footer';

export default component;
